import { createNode, TemporalValueUnion } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { objectToTemporal } from '../../utils/temporal';

export const CompareDateTime = createNode({
    id: 'Compare Date/Time',
    name: 'Compare Date/Time',
    description: 'Compares two Date, Time, DateTime, or ZonedDateTime values',
    aiDescription:
        'Takes two temporal values of the same type on the "First" and "Second" ports and outputs boolean results on "Before", "Equal", and "After" ports indicating their relative ordering.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        First: { kind: 'generic', identifier: 'T', extends: TemporalValueUnion },
        Second: { kind: 'generic', identifier: 'T' },
    },
    outPorts: {
        Before: { kind: 'boolean' },
        Equal: { kind: 'boolean' },
        After: { kind: 'boolean' },
    },
    execute: function (input) {
        const first = objectToTemporal(input.inPorts.First);
        const second = objectToTemporal(input.inPorts.Second);

        let comparison: number;
        if (first instanceof Temporal.PlainDate && second instanceof Temporal.PlainDate) {
            comparison = Temporal.PlainDate.compare(first, second);
        } else if (first instanceof Temporal.PlainTime && second instanceof Temporal.PlainTime) {
            comparison = Temporal.PlainTime.compare(first, second);
        } else if (first instanceof Temporal.PlainDateTime && second instanceof Temporal.PlainDateTime) {
            comparison = Temporal.PlainDateTime.compare(first, second);
        } else if (first instanceof Temporal.ZonedDateTime && second instanceof Temporal.ZonedDateTime) {
            comparison = Temporal.ZonedDateTime.compare(first, second);
        } else {
            comparison = 0;
        }

        return {
            output: {
                Before: comparison < 0,
                Equal: comparison === 0,
                After: comparison > 0,
            },
        };
    },
});
